// 头部导航
export const headerRouter = [
  { pageTit: '首页', sign: 'main' },
  { pageTit: '公司介绍', sign: 'introduce' },
  { pageTit: '产品&解决方案', sign: 'product' },
  { pageTit: '新闻动态', sign: 'news' },
  { pageTit: '加入我们', sign: 'joinWe' },
];
